(function () {
  const sections = document.querySelectorAll('.store-locator-list[data-section-id]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const searchInput = section.querySelector('[data-store-locator-search]');
    const cards = section.querySelectorAll('[data-store-locator-card]');
    const mapFrames = section.querySelectorAll('[data-store-locator-map-frame]');

    if (!cards.length) return;

    function setActiveCard(activeIndex) {
      const idx = parseInt(activeIndex, 10);
      cards.forEach((card, i) => {
        card.classList.toggle('store-locator-list__card--active', i === idx);
      });
      mapFrames.forEach((frame, i) => {
        frame.classList.toggle('store-locator-list__map-iframe-wrapper--active', i === idx);
      });
    }

    function filterCards(query) {
      const q = (query || '').trim().toLowerCase();
      let visibleCount = 0;
      let firstVisibleIndex = -1;

      cards.forEach((card, i) => {
        const searchText = (card.getAttribute('data-search-text') || '').toLowerCase();
        const matches = !q || searchText.includes(q);
        card.classList.toggle('hidden', !matches);
        if (matches) {
          visibleCount++;
          if (firstVisibleIndex === -1) firstVisibleIndex = i;
        }
      });

      if (firstVisibleIndex >= 0) {
        setActiveCard(firstVisibleIndex);
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filterCards(this.value);
      });
      searchInput.addEventListener('search', function () {
        filterCards(this.value);
      });
    }

    cards.forEach((card, index) => {
      card.addEventListener('click', function () {
        if (this.classList.contains('hidden')) return;
        setActiveCard(index);
      });
    });

    setActiveCard(0);
  });
})();
